export function AddPayment() {
    return (
        <div>Coming soon</div>
    )
}